import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// Browser history must not change the background page while a dialog is open.
export const modalNavigationGuard = (): boolean =>
  inject(Router).getCurrentNavigation()?.trigger !== 'popstate' ||
  !inject(NgbModal).hasOpenModals();
